import React from "react";
import CheckBox from "../../../../../../../_components/Checkbox";

export default (props) => {
  const handleChange = (value) => {
    props.onChange(value);
  };
  return (
    <div className={props.step === "type" ? "row py-4" : "d-none"}>
      <div className="col-md-4">
        <CheckBox
          label="Pessoa Física"
          checked={props.type === 1}
          itemKey="pf"
          onClick={(value) => handleChange(1)}
        />
      </div>
      <div className="col-md-4">
        <CheckBox
          label="Pessoa Jurídica"
          checked={props.type === 2}
          itemKey="pf"
          onClick={(value) => handleChange(2)}
        />
      </div>
      <div className="col-md-4">
        <CheckBox
          label="MEI"
          checked={props.type === 3}
          itemKey="pf"
          onClick={(value) => handleChange(3)}
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Branches/Branch/Create/components/BranchType/index.jsx